








































































































































































import i18n from "../../../locale";
import { Dictionary } from "lodash";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { ACTION } from ".";
import {
  ApiMessage,
  CustomersApi,
  EquipmentModel,
  EquipmentsApi,
  GetCustomersResponse,
  GetLocationsCustomerResponse,
  GetLocationUnitsResponse,
  GetVariablesResponse,
  LocationsApi,
  VariablesApi,
} from "../../../apis";

extend("file-type", {
  validate: () => {
    return true;
  },
  message: i18n.t("message.invalid").toString(),
});

@Component({
  components: { ValidationProvider, ValidationObserver },
})
export default class AddEquipment extends Vue {
  @Prop({ default: false }) value: Boolean;
  @Prop({}) mode: ACTION;
  @Prop({ default: {} }) selectedEquipment: EquipmentModel;
  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;

  getCustomersResponse: GetCustomersResponse = null;
  getLocationsCustomerResponse: GetLocationsCustomerResponse = null;
  getLocationUnitsResponse: GetLocationUnitsResponse = null;
  getVariablesResponse: GetVariablesResponse = null;
  formEquipment?: {
    customerId?: string;
    locationId?: string;
    unitId?: string;
    variableId?: string;
    equipmentName?: string;
    totalTime?: number;
    maintainanceDate?: string;
    files?: File[];
  } = {};
  isRemoveFile = false;

  get apiMessages(): Dictionary<ApiMessage[]> {
    return this.$store.getters.apiMessages;
  }

  @Watch("apiMessages", { deep: true })
  apiMessagesWatch(messages: Dictionary<ApiMessage[]>) {
    this.$util.showApiError(messages, this.observer);
  }

  get show() {
    this.formEquipment = {
      customerId: "",
      locationId: "",
      unitId: "",
      variableId: "",
      equipmentName: "",
      maintainanceDate: "",
      totalTime: null,
      files: [],
    };
    return this.value;
  }

  set show(value) {
    if (this.observer) this.observer.reset();
    this.$emit("input", value);
  }

  get CUSTOMERS(): { text: string; value: string }[] {
    return this.getCustomersResponse
      ? this.getCustomersResponse.data.map((val) => ({
          value: val.id,
          text: val.companyName,
        }))
      : [];
  }

  get LOCATIONS() {
    return this.getLocationsCustomerResponse
      ? this.getLocationsCustomerResponse.data.map((val) => ({
          value: val.id,
          text: val.locationName,
        }))
      : [];
  }

  get UNITS() {
    return this.getLocationUnitsResponse
      ? this.getLocationUnitsResponse.data.map((val) => ({
          value: val.id,
          text: val.name,
        }))
      : [];
  }

  get VARIABLES() {
    if (this.mode === ACTION.ADD || !this.selectedEquipment.variable) {
      return this.getVariablesResponse
        ? this.getVariablesResponse.data
            .filter((val) => val.operationTime)
            .map((val) => ({
              value: val.id,
              text: this.lodash.join(
                [
                  (val.variableName || "").trim(),
                  (val.memory || "").trim(),
                  (val.controller || "").trim(),
                ],
                " - "
              ),
            }))
        : [];
    }
    return this.getVariablesResponse
      ? [
          {
            text: this.lodash.join(
              [
                (this.selectedEquipment.variable.variableName || "").trim(),
                (this.selectedEquipment.variable.memory || "").trim(),
                (this.selectedEquipment.controllerName || "").trim(),
              ],
              " - "
            ),
            value: this.selectedEquipment.variable.id,
          },
          ...this.getVariablesResponse.data
            .filter((val) => val.operationTime)
            .map((val) => ({
              value: val.id,
              text: this.lodash.join(
                [val.variableName, val.memory, val.controller],
                " - "
              ),
            })),
        ]
      : [];
  }

  @Watch("formEquipment.customerId")
  async onCustomerIdWatch(newVal: string) {
    if (!newVal) return;
    this.getLocationsCustomerResponse = (
      await new CustomersApi().getActiveLocationsByCustomerId({
        id: this.formEquipment.customerId,
      })
    ).data;
  }

  @Watch("formEquipment.locationId")
  async onLocationIdWatch(newVal: string) {
    if (!newVal) return;
    this.getLocationUnitsResponse = (
      await new LocationsApi().getUnitsByLocationId({
        id: this.formEquipment.locationId,
      })
    ).data;
  }

  @Watch("formEquipment.unitId")
  async onUnitIdWatch(newVal: string) {
    if (!newVal) return;
    this.getVariablesResponse = (
      await new VariablesApi().getVariablesByUnitIdForEquipment({
        id: this.formEquipment.unitId,
      })
    ).data;
  }

  clearAllFile() {
    this.isRemoveFile = true;
  }

  onChangeFile(files: any) {
    this.formEquipment.files = files;
  }

  async onSubmit() {
    const valid = await this.observer.validate();
    if (!valid) {
      this.$util.goToErrorField(this.observer);
      return;
    }
    this.$util.showLoading();
    try {
      if (this.mode === ACTION.ADD) {
        await new EquipmentsApi().addEquipment({
          files: this.formEquipment.files,
          customerId: this.formEquipment.customerId,
          locationId: this.formEquipment.locationId,
          unitId: this.formEquipment.unitId,
          variableId: this.formEquipment.variableId,
          equipmentName: this.formEquipment.equipmentName,
          totalTime: this.formEquipment.totalTime,
        });
      }

      if (this.mode === ACTION.EDIT) {
        await new EquipmentsApi().putEquipment({
          removeFile: this.isRemoveFile,
          id: this.selectedEquipment.id,
          files: this.formEquipment.files,
          customerId: this.formEquipment.customerId,
          locationId: this.formEquipment.locationId,
          unitId: this.formEquipment.unitId,
          variableId: this.formEquipment.variableId || undefined,
          equipmentName: this.formEquipment.equipmentName,
          totalTime: this.formEquipment.totalTime,
        });
      }
      this.show = false;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async onShow() {
    this.getCustomersResponse = (await new CustomersApi().getAllCustomerByStringAndStatus({
      keyword: "",
      status: "Active",
    })).data;
    if (this.mode === ACTION.EDIT) {
      this.formEquipment.customerId = this.selectedEquipment.customer.id;
      this.formEquipment.locationId = this.selectedEquipment.location.id;
      this.formEquipment.unitId = this.selectedEquipment.unit.id;
      if (this.selectedEquipment.variable)
        this.formEquipment.variableId = this.selectedEquipment.variable.id;
      this.formEquipment.equipmentName = this.selectedEquipment.equipmentName;
      this.formEquipment.totalTime = this.selectedEquipment.totalTime;
      if (this.selectedEquipment.attachFileNames) {
        this.formEquipment.files = this.selectedEquipment.attachFileNames.map((file) => new File(
          [],
          file
        ));
      }
    }
  }
}
